<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration Step 3 of 6
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Contact Information
                    </template>

                    <template #form>
                        <div class="col-span-3">
                            <label class="flex flex-col">
                                <div>
                                   First Name <span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 mr-2 block w-half"
                                    v-model="form.authorized_rep_first_name"
                                    placeholder=""
                                />
                            </label>
                        </div>

                        <div class="col-span-3">
                            <label class="flex flex-col">
                                <div>
                                   Last Name <span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 mr-2 block w-half"
                                    v-model="form.authorized_rep_last_name"
                                    placeholder=""
                                />
                            </label>
                        </div>
                        

                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                   Email <span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 mr-2 block w-full"
                                    v-model="form.authorized_rep_email"
                                    placeholder=""
                                />
                            </label>
                        </div>

                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                   Phone Number <span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 mr-2 block w-full"
                                    v-model="form.authorized_rep_phone_number"
                                    placeholder=""
                                />
                            </label>
                        </div>

                        <template v-if="$page.props.a2p.is_business">

                            <div class="col-span-6">
                                <label class="flex flex-col">
                                    <div>
                                    Job Title <span class="required">*</span>
                                    </div>
                                    <jet-input
                                        class="mt-1 mr-2 block w-full"
                                        v-model="form.authorized_rep_job_title"
                                        placeholder=""
                                    />
                                </label>
                            </div>

                            <div class="col-span-6">
                                <label class="flex flex-col">
                                    <div>
                                    Job Position <span class="required">*</span>
                                    </div>
                                    <multiselect
                                        :options="jobPositionOptions"
                                        v-model="selectedJobPosition"
                                        :searchable="false"
                                        :clearable="false"
                                        select-label=""
                                        deselect-label=""
                                        label="label"
                                        placeholder="Select"
                                    />
                                </label>
                            </div>

                        </template>

                    </template>
                    <template #actions>
                        <Link :href="route('a2p.step2')" class="mr-auto" >
                            <jet-button secondary type="button">
                                Back
                            </jet-button>
                        </Link>

                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Next
                        </jet-button>
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import stateSelector from "../../components/Address/StateSelector";
import provinceSelector from "../../components/Address/ProvinceSelector";

export default {
    name: 'A2P-AuthorizedRepresentative',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        //vSelect,
        stateSelector,
        provinceSelector
    },
    data() {
        return {
            selectedJobPosition: null,
            form: this.$inertia.form(
                {
                    _method: "POST",
                    authorized_rep_first_name: this.$page.props.a2p.authorized_rep_first_name,
                    authorized_rep_last_name: this.$page.props.a2p.authorized_rep_last_name,
                    authorized_rep_email: this.$page.props.a2p.authorized_rep_email,
                    authorized_rep_phone_number: this.$page.props.a2p.authorized_rep_phone_number,
                    authorized_rep_job_title: this.$page.props.a2p.authorized_rep_job_title,
                    authorized_rep_job_position: this.$page.props.a2p.authorized_rep_job_position,
                    step: 3,
                },
                {
                }
            ),
        }
    },
    computed: {
        goodToContinue() {
            if (
                !this.form.authorized_rep_first_name || 
                !this.form.authorized_rep_last_name ||
                !this.form.authorized_rep_email ||
                !this.form.authorized_rep_phone_number
            ) return false;

            if (  this.$page.props.a2p.is_business && 
                (
                    !this.form.authorized_rep_job_position ||
                    !this.form.authorized_rep_job_title
                ) 
            ) return false;
            

            return true;
        },
        jobPositionOptions() {
            return [
                { value:"CEO", label: "CEO"},    
                { value:"CFO", label: "CFO"},
                { value:"VP", label: "VP"},
                { value:"Director", label: "Director"},
                { value:"GM", label: "GM"},
                { value:"General_Counsel", label: "General Counsel"},
                { value:"Other", label: "Other"},
            ]
        },
       
    },
    mounted() {
        if(!this.$page.props.a2p.authorized_rep_first_name) {
            //lets preload fields with the current user
            this.form.authorized_rep_first_name = this.$page.props.auth.user.name;
            this.form.authorized_rep_email = this.$page.props.auth.user.email;
            this.form.authorized_rep_phone_number = this.$page.props.auth.user.organization.phone_verification_meta.to;
        }
        this.selectedJobPosition = this.jobPositionOptions.find(opt => opt.value === this.form.authorized_rep_job_position) || null;
    },
    methods: {
        saveProgress() {
            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
        selectedJobPosition(newVal) {
            this.form.authorized_rep_job_position = newVal ? newVal.value : null;
        }
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
